import * as React from 'react';

import * as _ from 'lodash';
import * as Bluebird from 'bluebird';
import { v4 as UUID } from 'uuid';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab, Toolbar,
    Button, IconButton,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider,
    Dialog, DialogTitle, DialogContent, DialogActions
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';

import { AgGridReact, AgGridColumn } from 'ag-grid-react';

import { useSnackbar } from 'notistack';

import { LouverSelector, LouverSelectorProps } from '../louverSelector';
import { LayoutEntity, LayoutEntityProps } from '../layoutEntity';
import { LayoutGrid, LayoutGridProps } from '../layoutGrid';

import { useServiceClient, usePreferences } from '../contexts';
import { CatalogEntry } from '../../lib/serviceClient';

import * as LouverSelectionService from '../../lib/services/louverSelection.selection';
import * as ConfigurationModelEntity from '../../lib/services/configuration.modelEntity';
import * as ConfigurationModelLayout from '../../lib/services/configuration.modelLayout';
import * as ConfigurationModelConstraint from '../../lib/services/configuration.modelConstraint';
import * as ConfigurationCore from '../../lib/services/configuration.core';
import * as ConfigurationLayout from '../../lib/services/configuration.projectionLayout';
import * as ConfigurationLayoutGrid from '../../lib/services/configuration.projectionLayoutGrid';
import * as ConfigurationIntegration from '../../lib/services/configuration.projectionIntegration';

import {
    LouverSelector as LouverSelectorXM,
    LouverSizing as LouverSizingXM,
    Entity as EntityXM,
    Grid as GridXM
} from '../xm';

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    },
    grow: {
        flexGrow: 1
    },
    sizesToolbar: {
        alignItems: 'flex-start'
    },
    sizesToolbarHeader: {
        flexGrow: 1
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    },
    entityContainer: {
        padding: theme.spacing(1),
        background: '#F2F3F4'
    },
    textarea: {
        // resize: 'vertical',
        fontSize: 8,
        overflow: 'auto',
        maxWidth: '100%',
        maxHeight: 400
        // whiteSpace: 'nowrap'
    },
    test: {
        padding: theme.spacing(2)
    }
}));

export function Louver() {
    const classes = styles();
    const serviceClient = useServiceClient();

    const { enqueueSnackbar } = useSnackbar();

    const [ selectorCoreEntity, setSelectorCoreEntity ] = React.useState<ConfigurationCore.Entity>();
    React.useEffect(() => {(async () => {
        const coreEntity = await serviceClient.getEntity('LV/LouverConfigurationSelector_Schema')
            .then(entityModel => serviceClient.createCoreEntity(entityModel));

        setSelectorCoreEntity(coreEntity);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient ]);

    const [ selectorLayoutEntity, setSelectorLayoutEntity ] = React.useState<ConfigurationLayout.Entity>();
    React.useEffect(() => {(async () => {
        if (!selectorCoreEntity)
            return;

        const layoutEntity = await serviceClient.getLayout('LV/LouverConfigurationSelector_Layout')
            .then(layoutEntity => serviceClient.createLayoutEntity(selectorCoreEntity, layoutEntity));

        setSelectorLayoutEntity(layoutEntity);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient, selectorCoreEntity ]);

    const [ sizesLayoutGrid, setSizesLayoutGrid ] = React.useState<ConfigurationLayoutGrid.Grid>();
    React.useEffect(() => {(async () => {
        if (!selectorCoreEntity)
            return;

        const gridModel = await serviceClient.getGrid('louverSizes');
        const grid = await serviceClient.createLayoutGrid(selectorCoreEntity, gridModel);
        setSizesLayoutGrid(grid);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient, selectorCoreEntity ]);

    const [ showPerformanceSelection, setShowPerformanceSelection ] = React.useState<boolean>(false);
    const onSelectByPerformanceClick = () => {
        setShowPerformanceSelection(true);
    }

    const onSelectorEntityChange: LayoutEntityProps['onChange'] = (e) => {(async () => {
        if (!selectorCoreEntity)
            return;

        const updateResults = await serviceClient.updateEntity(selectorCoreEntity, e.state);
        setSelectorCoreEntity(new ConfigurationCore.Entity(selectorCoreEntity));
    })()}
    const onAddSizeClick = () => {(async () => {
        if (!selectorCoreEntity)
            return;

        await serviceClient.addChild(selectorCoreEntity, 'LouverConfigurationSelector_To_LouverProduct');
        setSelectorCoreEntity(new ConfigurationCore.Entity(selectorCoreEntity));
    })()}
    const onCloseDialog = () => {
        setShowPerformanceSelection(false);
    }

    const [ selectedPerformanceSizes, setSelectedPerformanceSizes ] = React.useState<ConfigurationCore.Entity[]>([]);
    const onPerformanceSelectedSizeChange: PerformanceSelectorProps['onSelectedSizeChange'] = (sizeEntities) => {
        setSelectedPerformanceSizes(sizeEntities);
    }
    const onAddPerformanceSizeClick= () => {(async () => {
        if (!selectorCoreEntity)
            return;

        const integrationEntities = await Bluebird.map(selectedPerformanceSizes, sizeEntity => serviceClient.createIntegrationProjection(sizeEntity));
        for (const integrationEntity of integrationEntities)
            await serviceClient.addChild(selectorCoreEntity, 'LouverConfigurationSelector_To_LouverProduct', integrationEntity);

        setSelectorCoreEntity(new ConfigurationCore.Entity(selectorCoreEntity));

        setShowPerformanceSelection(false);
    })()}

    return (
        <React.Fragment>
            <Grid container xs={12} spacing={1} alignItems="flex-start">
                <Grid item xs={12}>
                    {selectorLayoutEntity && <LayoutEntity entity={selectorLayoutEntity} onChange={onSelectorEntityChange} />}
                </Grid>

                <Grid item xs={12}>
                    <Button variant="contained" onClick={onSelectByPerformanceClick}>Select by Performance</Button>
                </Grid>

                <Grid item xs={12}>
                    {sizesLayoutGrid && <Paper>
                        <AppBar position="static">
                            <Toolbar variant="dense">
                                <IconButton edge="start" color="inherit">
                                    <Icons.Add onClick={onAddSizeClick} />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <LayoutGrid grid={sizesLayoutGrid} />
                    </Paper>}
                </Grid>
            </Grid>

            <Dialog open={!!showPerformanceSelection} onClose={onCloseDialog} fullWidth maxWidth="lg">
                <DialogTitle id="form-dialog-title">Louver Performance Selector</DialogTitle>
                <DialogContent>
                    {showPerformanceSelection && <PerformanceSelector onSelectedSizeChange={onPerformanceSelectedSizeChange} />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onAddPerformanceSizeClick}>Add</Button>
                    <Button onClick={onCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

// interface SelectionDialogProps {
//     show?: boolean;
//     // onSave?: (settings: Settings) => void;
//     onClose?: () => void;
// }
// function SelectionDialog({ show, onClose }: SelectionDialogProps) {
//     return (
//         <Dialog open={!!show} onClose={onClose}>
//             <DialogTitle id="form-dialog-title">Settings</DialogTitle>
//             <DialogContent>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={onSaveHandler}>Save</Button>
//                 <Button onClick={onClose}>Cancel</Button>
//             </DialogActions>
//         </Dialog>
//     );
// }

interface PerformanceSelectorProps {
    onSelectedSizeChange?: (entities: ConfigurationCore.Entity[]) => void;
}
function PerformanceSelector(props: PerformanceSelectorProps) {
    const serviceClient = useServiceClient();
    const { enqueueSnackbar } = useSnackbar();

    const [ coreEntity, setCoreEntity ] = React.useState<ConfigurationCore.Entity>();
    React.useEffect(() => {(async () => {
        const coreEntity = await serviceClient.getEntity('LV/LouverPerformanceSelector_Schema')
            .then(entityModel => serviceClient.createCoreEntity(entityModel));

        setCoreEntity(coreEntity);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient ]);

    const [ layoutEntity, setLayoutEntity ] = React.useState<ConfigurationLayout.Entity>();
    React.useEffect(() => {(async () => {
        if (!coreEntity)
            return;

        const layoutEntity = await serviceClient.getLayout('LV/LouverPerformanceSelector_CAPS_Layout')
            .then(layoutEntity => serviceClient.createLayoutEntity(coreEntity, layoutEntity));

        setLayoutEntity(layoutEntity);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient, coreEntity ]);

    const [ performanceEntityCoreEntities, setPerformanceEntityCoreEntities ] = React.useState<ConfigurationCore.Entity[]>();
    React.useEffect(() => {(async () => {
        if (!coreEntity)
            return;

        setPerformanceEntityCoreEntities(undefined);
        setSizesLayoutGrid(undefined);
        const coreEntities = await serviceClient.selectLouvers(coreEntity);

        setPerformanceEntityCoreEntities(coreEntities);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient, coreEntity ]);

    const [ sizesLayoutGrid, setSizesLayoutGrid ] = React.useState<ConfigurationLayoutGrid.Grid>();
    React.useEffect(() => {(async () => {
        if (!performanceEntityCoreEntities)
            return;

        const gridModel = await serviceClient.getGrid('louverPerformanceSizes');
        const grid = await serviceClient.createLayoutGrid(performanceEntityCoreEntities, gridModel);
        setSizesLayoutGrid(grid);
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
        console.error(err)
    })}, [ serviceClient, performanceEntityCoreEntities ]);

    const onEntityChange: LayoutEntityProps['onChange'] = (e) => {(async () => {
        if (!coreEntity)
            return;

        const updateResults = await serviceClient.updateEntity(coreEntity, e.state);
        setCoreEntity(new ConfigurationCore.Entity(coreEntity));
    })()}

    const onSizesGridSelectionChanged: LayoutGridProps['onSelectionChanged'] = (ids) => {
        if (!performanceEntityCoreEntities)
            return;

        if (props.onSelectedSizeChange) {
            const coreEntities = _.compact(ids.map(id => performanceEntityCoreEntities.find(c => c.entityId === id)));
            props.onSelectedSizeChange(coreEntities);
        }
    }

    return (
        <React.Fragment>
            <Grid container xs={12} spacing={1} alignItems="flex-start">
                <Grid item xs={12}>
                    {layoutEntity && <LayoutEntity entity={layoutEntity} onChange={onEntityChange} />}
                </Grid>

                <Grid item xs={12}>
                    {sizesLayoutGrid ? <LayoutGrid grid={sizesLayoutGrid} onSelectionChanged={onSizesGridSelectionChanged} /> : <em>Loading...</em>}
                </Grid>
            </Grid>
        </React.Fragment>
    )
}